import React from "react";
import { Stack, TextField, Box } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const DateField = props => {
  const {
    label,
    value,
    onClick
  } = props;

  return (
    <div style={{ position: 'relative' }}>
      <div 
	style={{
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  right: 0,
	  bottom: 0,
	  zIndex: 1,
	  cursor: 'pointer'
	}}
	onClick={onClick}
      />
      <DatePicker
	label={label}
	value={value && dayjs(value)}
	renderInput={params => (
	  <TextField
	    {...params}
	    fullWidth
	    variant="filled"
            sx={{ background: 'white' }}
	    InputProps={{
	      ...params.InputProps,
	      disableUnderline: true
	    }}
	    InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
	  />
	)}
      />
    </div>
  )
}

const CalendarForm = props => {
  const {
    startDate,
    endDate,
    onStartDate,
    onEndDate
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack direction={{ xs: 'row', md: 'row' }} spacing={2} alignItems="stretch" flexWrap={{ xs: 'wrap', md: 'nowrap' }}>
        <Box sx={{ flex: { xs: '0 0 calc(50% - 8px)', md: 1 } }}>
          <DateField
            label="Start Date"
            value={startDate}
            onClick={onStartDate}
          />
        </Box>
        <Box sx={{ flex: { xs: '0 0 calc(50% - 8px)', md: 1 } }}>
          <DateField
            label="End Date"
            value={endDate}
	onClick={onEndDate}
          />
        </Box>
      </Stack>
    </LocalizationProvider>
  );
};

export default CalendarForm;
